import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { FirebaseCallableFunctionError } from 'src/app/errors/firebase-callable-function-error';
import { TopicService } from 'src/app/services/topic.service';

import * as TopicActions from 'src/app/actions/topic.actions';

@Injectable()
export class TopicEffects {
  private LOG_SOURCE = this.constructor.name;

  getTopic$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TopicActions.getTopic),
      switchMap(action =>
        this.topicService.getTopic(action.request).pipe(
          map(response => TopicActions.getTopicSuccess({ response })),
          catchError(e => of(TopicActions.getTopicFailure({ error: FirebaseCallableFunctionError.from(e) })))
        )
      )
    )
  );

  constructor(private actions$: Actions, private topicService: TopicService) {}
}
